import ContentLoader from 'react-content-loader'
import React from 'react'

const LoadingSkeleton = () => (
  <ContentLoader className="notifications-overview__skeleton-container">
    <rect height="300" rx="0" ry="0" width="500" x="0" y="0" />
  </ContentLoader>
)

export default LoadingSkeleton
